import PropTypes from 'prop-types';
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";

import { MainLayout } from "@gyandiksha/shared-ui/layouts";
import { ProtectedRoute, PublicRoute, isPublicPath } from "@gyandiksha/shared-ui/routes";
import { defaultSidebarMenuConfig } from "../navigation/sidebarmenu.config";
import { PageLoader, PageNotFound } from "@repo/design-system/components/ui";

// Sidebar menu config & Auth
import { COGENTROLES, getAuthProps, getFirstNavigationPath } from "@gyandiksha/shared-ui";
import { MODULE_IDS, useSidebarMenuConfig } from '@gyandiksha/shared-ui/hooks/useSidebarMenuConfig.js';

const AppRoutes = (props) => {

    const isStudent = getAuthProps()?.roleId === COGENTROLES.STUDENT;
    // Public visitors have no session — don't fetch the (authenticated) sidebar menu for them
    const isPublicRoute = isPublicPath(window.location.pathname, props.publicRoutes);
    const { sidebarMenuConfig, isFetching } = useSidebarMenuConfig({ moduleId: MODULE_IDS.usk_student_skill_passport, skip: isStudent || isPublicRoute });
    const defaultPath = getFirstNavigationPath(sidebarMenuConfig)
        || getFirstNavigationPath(defaultSidebarMenuConfig)
        || "/dashboard";

    return (
        <Router>
            <Routes>
                {/* Public routes — outside ProtectedRoute/MainLayout, no auth required */}
                {props.publicRoutes.map((route) => (
                    <Route key={route.path} path={route.path}
                        element={<PublicRoute><route.component /></PublicRoute>} />
                ))}
                <Route path="/" element={
                    !isStudent && isFetching ? <PageLoader /> : <Navigate to={defaultPath} replace />
                } />
                <Route name="Layout" path="/"
                    element={
                        <ProtectedRoute>
                            {!isStudent && isFetching ? (
                                <PageLoader />
                            ) : (
                                <MainLayout componentRoutes={props.componentRoutes}
                                    isVisibleHeaderLogo={getAuthProps()?.roleId === undefined ? true : false}
                                    sidebarMenuConfig={getAuthProps()?.roleId === undefined ?
                                        [] : (sidebarMenuConfig || defaultSidebarMenuConfig)} />
                            )}
                        </ProtectedRoute>
                    }>
                    {props.componentRoutes.map((route) => (
                        <Route key={route.path} path={route.path}
                            name=""
                            element={< route.component securityKey={route.securityKey} />} />
                    ))}

                    {props.componentRoutes.map((route) => (
                        route?.children?.map((childRoute) => (
                            <Route
                                key={childRoute.path}
                                path={childRoute.path}
                                element={<childRoute.component securityKey={childRoute?.securityKey} />}
                            />
                        ))
                    ))}

                </Route>
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </Router>
    );
};

AppRoutes.propTypes = {
    componentRoutes: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            component: PropTypes.elementType.isRequired,
            securityKey: PropTypes.string.isRequired,
            children: PropTypes.arrayOf(
                PropTypes.shape({
                    path: PropTypes.string.isRequired,
                    component: PropTypes.elementType.isRequired,
                    securityKey: PropTypes.string.isRequired,
                })
            ),
        })
    ).isRequired,
    publicRoutes: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            component: PropTypes.elementType.isRequired,
        })
    ),
};

AppRoutes.defaultProps = {
    publicRoutes: [],
};

export default AppRoutes;
